import '@awesome.me/webawesome/dist/components/button/button.js';

import { useTranslation } from 'react-i18next';

interface ModeSelectProps {
  onSelectBraindump: () => void;
  onSelectConversational: () => void;
}

export function ModeSelect({ onSelectBraindump, onSelectConversational }: ModeSelectProps) {
  const { t } = useTranslation();

  return (
    <div
      style={{
        maxWidth: '480px',
        width: '100%',
        margin: '0 auto',
        textAlign: 'center',
        padding: 'var(--space-xl)',
      }}
    >
      <h1
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: '1.75rem',
          marginBottom: 'var(--space-2xl)',
        }}
      >
        {t('onboarding:modeSelect.title')}
      </h1>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-md)' }}>
        <button
          onClick={onSelectBraindump}
          style={{
            background: 'var(--color-card)',
            border: '1px solid var(--color-card-border)',
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--space-lg)',
            color: 'var(--color-text-primary)',
            textAlign: 'left',
            cursor: 'pointer',
            transition: 'background var(--transition-fast)',
          }}
        >
          <div style={{ fontSize: '1.1rem', fontWeight: 600, marginBottom: 'var(--space-xs)' }}>
            {t('onboarding:modeSelect.braindump')}
          </div>
          <div style={{ fontSize: '0.875rem', color: 'var(--color-text-secondary)' }}>
            {t('onboarding:modeSelect.braindumpDesc')}
          </div>
        </button>

        <button
          onClick={onSelectConversational}
          style={{
            background: 'var(--color-card)',
            border: '1px solid var(--color-card-border)',
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--space-lg)',
            color: 'var(--color-text-primary)',
            textAlign: 'left',
            cursor: 'pointer',
            transition: 'background var(--transition-fast)',
          }}
        >
          <div style={{ fontSize: '1.1rem', fontWeight: 600, marginBottom: 'var(--space-xs)' }}>
            {t('onboarding:modeSelect.conversational')}
          </div>
          <div style={{ fontSize: '0.875rem', color: 'var(--color-text-secondary)' }}>
            {t('onboarding:modeSelect.conversationalDesc')}
          </div>
        </button>
      </div>
    </div>
  );
}
